import { render, staticRenderFns } from "./QuestionFirst.vue?vue&type=template&id=6b80a505"
import script from "./QuestionFirst.vue?vue&type=script&lang=js"
export * from "./QuestionFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports